// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__lXOX4","selected":"Chip_selected__38OnH"};